import { Result } from './model';
export var asOptional = function (sanitizer) {
    return function (value, path) { return value == null
        ? Result.ok(undefined)
        : sanitizer(value, path); };
};
